export default {
  SET_CUSTOMER_SETTLEMENTS(state, payload) {
    state.customerSettlements = payload
  },
}
